import {
    AlgoliaMapBounds,
    AuctionNearMeHit,
    AuctionsNearMeRouteParams,
} from '@/pages/AuctionsNearMe/types/AuctionsNearMe.types';
import { DataLoaderTypedParams } from '@/types/DataLoaderParams';
import {
    defaultAuctionsNearMeBounds,
    defaultHitsPerPage,
} from '@/pages/AuctionsNearMe/constants/AuctionsNearMeConstants';
import { fetchCatalogsIfNeeded } from '@/redux/modules/catalog/catalog.actions';
import { fetchGeoAreaIfNeeded, loadAllGeoAreas } from '@/redux/modules/geoArea/geoArea';
import { getAlgoliaMapFilters } from '@/pages/AuctionsNearMe/helpers/getAlgoliaMapFilters';
import { populateSsrAuctionsNearMeHits } from '@/redux/modules/auctionsNearMe/auctionsNearMe';
import algoliasearch from 'algoliasearch';

export const loadAuctionsNearMePageData = async ({
    match,
    store,
}: DataLoaderTypedParams<AuctionsNearMeRouteParams>) => {
    const geoAreaId = Number(match.params.geoAreaId || 0);
    const { dispatch, getState } = store;

    let mapBounds: AlgoliaMapBounds = defaultAuctionsNearMeBounds;
    await dispatch(loadAllGeoAreas());
    await dispatch(fetchGeoAreaIfNeeded(geoAreaId));
    if (geoAreaId) {
        const geoArea = getState().geoArea.byId[geoAreaId];
        mapBounds = {
            northEast: {
                lat: geoArea.northEastLatitude,
                lng: geoArea.northEastLongitude,
            },
            southWest: {
                lat: geoArea.southWestLatitude,
                lng: geoArea.southWestLongitude,
            },
        };
    }

    const indexName = 'Available_Catalogs';
    const { algoliaApiKey, algoliaAppId } = getState().config;
    const client = algoliasearch(algoliaAppId, algoliaApiKey);
    const index = client.initIndex(indexName);
    const { hits } = await index.search<AuctionNearMeHit>('', {
        filters: getAlgoliaMapFilters(),
        hitsPerPage: defaultHitsPerPage,
        insideBoundingBox: [
            [mapBounds.northEast.lat, mapBounds.northEast.lng, mapBounds.southWest.lat, mapBounds.southWest.lng],
        ],
    });
    const catalogIds = hits.map(({ Catalog }) => Catalog.ID);
    await Promise.all([dispatch(populateSsrAuctionsNearMeHits(hits)), dispatch(fetchCatalogsIfNeeded({ catalogIds }))]);
};
